import React, {useState, Suspense} from 'react'
import { Canvas } from '@react-three/fiber';
import { OrbitControls, softShadows, Environment } from '@react-three/drei'
import Cabin from './components/Cabin'
import CabinConfiguratorPad from './components/CabinConfiguratorPad'
//import Selector from './components/LiftParametersSelector'

softShadows()

export default function MainCabin(props) {
  //const envcolor='#a3b1af'
  //const envcolor='#5c7a82'
  const envcolor='#2a3e52';
  
  const [ current, setCurrent ] = useState(null);
  const backTop = props.config.cabin.backTop;
  const backBottom = props.config.cabin.backBottom;
  const monitor = props.config.cabin.monitor;
  const carpet = props.config.cabin.carpet;
  const commands = props.config.cabin.commands;

  const isJson = str=>{
    try { JSON.parse(str);} 
    catch (e) { return false;}
    return true;
  }  

  const selectItemTexture = (item, config)=>{
    props.config.cabin[item] = isJson(config)?JSON.parse(config):config;
    props.updateConfig(props.config);
    
  }

  const deg2rad = degrees => degrees * (Math.PI / 180);

  return(
    <>
      <CabinConfiguratorPad 
          config={props.config.cabin} 
          selectedItem={current} 
          select={selectItemTexture} 
          onClick={setCurrent}/>
      <Canvas  
        camera={{ position: [350, 80, 200], fov: 52, rotation: deg2rad(-45)} } 
        style={{height: '100vh'}}>

        <color attach="background" args={[envcolor]} />

        <Suspense fallback={null}>
          <OrbitControls autoRotate={false}/>
          <Environment
              background={false}
              preset='apartment'
          />      
          <Cabin 
            backTop={backTop} 
            backBottom={backBottom} 
            carpet={carpet}
            commands={commands}
            monitor={monitor}
            //onClick={setCurrent}
            current={current}
            dim={[
                    props.config.lift.model.dimensions.width-props.config.cabin.cabinOffset,
                    props.config.lift.model.dimensions.depth-props.config.cabin.cabinOffset,
                    props.config.cabin.height
                  ]}
            position={[0, -60, 0]}
          />
        </Suspense>
      </Canvas>

  </>
  )
}
